<template>
  <div class="modal">
    <div class="modal__mask">
      <div class="modal__wrapper">
        <div class="modal__container">
          <div class="modal__header">
            <div class="modal__title">{{ modalName }}</div>
            <div class="modal__close"></div>
            <div
              class="modal__close"
              v-on:click="
                () => {
                  this.$emit('showStatus', false);
                }
              "
            ></div>
          </div>

          <div class="modal__body">
            <!-- <div class="email-fields">
              <EmailField label="To" v-model="emails.to" />
              <EmailField label="Cc" v-model="emails.cc" />
              <EmailField label="Bcc" v-model="emails.bcc" />
            </div> -->
            
            <div class="email-field">
              <label>Subject:</label>
              <div class="email-input-container">
                <input
                  type="text"
                  v-model="currentSubjectText"
                  placeholder="Enter subject"
                />
              </div>
            </div>

            <div class="report-body">
              <textarea class="report-item__textarea" v-model="currentText" ref="textarea" style="" rows="10" name="" id=""></textarea>
              
            </div>

            <Multiselect
              v-model="this.selectedVariable"
              :options="this.availableVariables"
              :searchable="true"
              :trackBy="'label'"
              placeholder="Select Field"
              label="label"
              track-by="label"
              mode="single"
              valueProp="id"
              @select="insertVariable"
            />
            <div class="switch-bar modal__switch-bar">
            </div>
            <div class="switcher-content">
              <div class="switcher-content__choose"></div>
            </div>
          </div>

          <div class="modal__footer">
            <div
              class="modal__close-button"
              v-on:click="
                () => {
                  this.$emit('showStatus', false);
                }
              "
            >
              <div class="close-button__img"></div>
              <span>Cancel</span>
            </div>
            
            <!-- <div
              class="modal__preview-button"
              v-on:click="
                () => {
                  this.emailOwnerPreviewPopUpShowStatus(true);
                }
              "
            >
              <div class="close-button__img"></div>
              <span>Preview</span>
            </div> -->

            <div
              class="modal__close-button"
              v-if="this.currentText !== this.templateText"
              v-on:click="reset"
            >
              Reset
            </div>

            <div
              class="modal__save-button"
              v-on:click="() => handleSave(offerId)"
            >
              <div class="save-button__img"></div>
              <span>Save</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <EmailOwnerPreviewPopUp
      v-if="showEmailOwnerPreviewPopUp"
      :offerId="offerId"
      :body="currentText"
      :template="currentText"
      :subject="subject"
      @showStatus="emailOwnerPreviewPopUpShowStatus"  
      /> -->
  </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";
import OfferApi from "@/api/tradingPlatform/offer";
// import EmailField from "./EmailField.vue";
import '@vueform/multiselect/themes/default.css';
// import EmailOwnerPreviewPopUp from "./EmailOwnerPreviewPopUp";

export default {
  name: "EmailOwnerTemplatePopUp",
  components: {
    Multiselect,
    // EmailField,
    // EmailOwnerPreviewPopUp,
  },
  props: {
    table: String,
    selectedReport: String,
    open: Boolean,
    recordKey: String || Number,
    offerId: Number,

    templateText: {
      type: String,
      default: ''
    },
    templateSubjectText: {
      type: String,
      default: ''
    }
  },
  emits: ["showStatus"],
  data: function () {
    return {

      modalName: "Edit Template",
      selectedVariable: null,
      availableVariables: [
        // { id: 'firstName', label: 'First Name' },
        // { id: 'lastName', label: 'Last Name' },
        // { id: 'email', label: 'Email Address' },
      ],
      currentText: this.templateText,
      subject: "",
      currentSubjectText: this.templateSubjectText,
      emails: {
        to: [],
        cc: [],
        bcc: [],
      },
      showEmailOwnerPreviewPopUp: false,
    };
  },
  watch: {
    
  },
  mounted() {
    this.getFields();
    this.getEmailTemplate();
  },
  computed: {
  },
  methods: {
    // insertVariable(variableObj) {
    //   console.log("insertVariable", variableObj);
    //   if (!variableObj || !variableObj.id) return;

    //   const textarea = this.$refs.textarea;
    //   const variable = `{{${variableObj.id}}}`;

    //   const start = textarea.selectionStart;
    //   const end = textarea.selectionEnd;
    //   const text = textarea.value;

    //   textarea.value =
    //     text.substring(0, start) + variable + text.substring(end);
    //   textarea.focus();
    //   textarea.setSelectionRange(
    //     start + variable.length,
    //     start + variable.length
    //   );

    //   this.selectedVariable = null;
    // },
    // insertVariable(value) {
    //   const textarea = this.$refs.textarea;
    //   const variable = `{{${value}}}`;

    //   if (!textarea) return;

    //   const start = textarea.selectionStart;
    //   const end = textarea.selectionEnd;
    //   const text = textarea.value;

    //   textarea.value =
    //     text.substring(0, start) + variable + text.substring(end);
    //   textarea.focus();
    //   textarea.setSelectionRange(start + variable.length, start + variable.length);

    //   // clear select after insert
    //   this.selectedVariable = null;
    // },

    reset() {
      this.currentText = this.templateText;
      this.currentSubjectText = this.templateSubjectText;
      this.selectedVariable = null;
    },

    insertVariable(value) {
      const textarea = this.$refs.textarea;
      const variable = `{{${value}}}`;

      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;

      this.currentText = text.substring(0, start) + variable + text.substring(end);
      this.$nextTick(() => {
        textarea.focus();
        textarea.setSelectionRange(start + variable.length, start + variable.length);
      });

      this.selectedVariable = null;
    },
    getFields() {
      OfferApi.getAllFields()
        .then((response) => {
          console.log("getFields", response);
          // for (const key in response.body) {
          //   if (Object.prototype.hasOwnProperty.call(object, key)) {
          //     const element = object[key];
              
          //   }
          // }
          if (Array.isArray(response.data.items)) {
            this.availableVariables = response.data.items.map(item => ({
              id: item.id,
              label: item.label,
            }));

            this.availableVariables.push(
              { id: 'custom_first_contact_name', label: 'First Contact - Name' }, //custom_charterer_name
              { id: 'custom_contacts_first_name', label: 'Contacts - First Name' }, //custom_charterers_first_name
              { id: 'custom_current_offer', label: 'Current Offer' }, //custom_current_offer
            );
            this.availableVariables.sort((a, b) => a.label.localeCompare(b.label));
          } else {
            console.warn('Expected array, got:', response.data.items);
          }
        })
        .catch((error) => {
          console.error("Error fetching fields:", error);
        });
    },

    getEmailTemplate() {
      OfferApi.getEmailTemplateByOfferId(this.offerId)
        .then((response) => {
          console.log("getEmailTemplate", response);
          if(response.data.body) {
            this.currentText = response.data.body;
          }

          if(response.data.subject) {
            this.currentSubjectText = response.data.subject;
          }
          this.emails.to = response.data.to;
          this.emails.cc = response.data.cc;
          this.subject = response.data.subject;
          // this.currentText = response.data.body;
        })
        .catch((error) => {
          console.error("Error fetching fields:", error);
        });
    },
    handleSave(offerId) {
      console.log("handleSave", this.currentText);
      // this.$emit('saveEmailTemplate', this.currentText);
      if(this.currentText === this.templateText) {
        // this.$emit('showStatus', false);
        this.currentText = "";
      }

      if(this.currentSubjectText === this.templateSubjectText) {
        this.currentSubjectText = "";
      }

      OfferApi.updateEmailTemplateByOfferId(offerId, this.currentText, this.currentSubjectText, this.emails.to, this.emails.cc)
        .then(() => {
          this.$emit('showStatus', false);
        })
        .catch((error) => {
          console.error("Error fetching fields:", error);
          this.$emit('showStatus', false);
        });
    },
    emailOwnerPreviewPopUpShowStatus(status) {
      this.showEmailOwnerPreviewPopUp = status;
      // console.log("emailOwnerPreviewPopUpShowStatus", status);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tables-panel {
  max-width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  padding-top: 20px;
}
.tables-items {
  display: flex;
}
.report-panel {
  max-width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
}

.report-body {
  /* height: 100%; */
  /* height: 700px; */
  overflow-y: auto;
  overflow-x: auto;
  position: relative;
  margin-top: 20px;
  margin-bottom: 20px;
  /* display: flex; */
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

td {
  border-right: 1px solid #d3dfed;
  border-bottom: 1px solid #d3dfed;
  /* padding: 15px; */
}

thead {
  background: #f6faff;
}

tbody {
  border-top: 1px solid #d3dfed;
  border-left: 1px solid #d3dfed;
}

.report-table {
  /* margin-top: 50px; */
  /* width: 100%; */
  table-layout: fixed;
  border-collapse: collapse;
  /* height: 90vh; */
  position: relative;
}

/* .report-table thead {
  background-color: #333;
  color: #fdfdfd;
  position: sticky;
} */

.report-table thead tr {
  /* display: block; */
  position: relative;
}

th {
  position: sticky;
  z-index: 1;
  /* border-top: 0px;
  border-right: 1px solid rgb(215, 214, 217);
  border-bottom: 1px solid rgb(215, 214, 217); */
  border: 0;
  padding: 5px 10px;
  color: rgb(255, 255, 255);
  -webkit-font-smoothing: antialiased;
  /* background-color: rgb(120, 117, 124); */
  /* background: #fff; */
  cursor: default;
  vertical-align: middle;

  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: #2d3757;
  /* text-align: left; */
}

.report-table__head {
  position: sticky;
  z-index: 1;
}

.btn-save {
  display: flex;
  justify-content: end;
}

.btn-save__body {
  background: rgb(106, 141, 255);
  color: #fff;
  font-size: 1.25em;
  padding: 10px 30px;
  margin-right: 20px;
  cursor: pointer;
}
.modal {
  position: absolute;
}

.modal__mask {
  position: fixed;
  z-index: 110;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* display: table; */
  display: flex;
  justify-content: center;
  /* align-items: center; */
  transition: opacity 0.3s ease;
  padding: 20px;
}

.modal__wrapper {
  margin: 40px;
  margin-bottom: 0;
  overflow-y: hidden;
  max-height: 100%;
  /* padding: 20px; */
}

.modal__container {
  /* overflow-y: scroll; */
  /* width: 300px; */
  margin: 0px auto;
  padding: 20px 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  width: 1000px;
}

@media screen and (max-width: 1200px) {
  .modal__container {
    /* overflow-y: scroll; */
    /* width: 300px; */
    margin: 0px auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    width: 100%;
    /* max-width: 800px; */
  }

  .modal__wrapper {
    width: 100%;
  }

  .modal__mask {
    box-sizing: border-box;
  }
}

.modal__header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal__header {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #d3dfed;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 20px;
}

.modal__title {
  padding: 5px 20px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  color: #2d3757;
}

.modal__close {
  position: absolute;
  top: 12px;
  right: 30px;
  cursor: pointer;
  width: 16px;
  height: 16px;
  background: url(@/assets/close.svg) no-repeat center center;
}

.modal__body {
  margin: 20px 0;
  padding-left: 30px;
  padding-right: 30px;
}

.modal__default-button {
  float: right;
}

.modal__footer {
  display: flex;
  justify-content: space-between;

  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;

  color: #2d3757;
  padding-left: 30px;
  padding-right: 30px;
}

.modal__close-button {
  border: 1px solid #2d3757;
  border-radius: 2px;
  padding: 14px 28px;
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.modal__close-button:hover {
  background-color: #50629b;
  color: white;
}

.modal__close-button:hover .close-button__img {
  filter: invert(100%) brightness(1000%);
}

.modal__preview-button {
  border: 1px solid #2d3757;
  border-radius: 2px;
  padding: 14px 28px;
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.modal__preview-button:hover {
  background-color: #50629b;
  color: white;
}

.modal__preview-button:hover .close-button__img {
  filter: invert(100%) brightness(1000%);
}

.close-button__img {
  width: 16px;
  height: 16px;
  background: url(@/assets/btn-close.svg) no-repeat center center;
  margin-right: 10px;
}

.modal__save-button,
.modal__submit-button {
  background: #2d3757;
  border-radius: 2px;
  padding: 14px 28px;
  color: #ffffff;
  margin-left: 15px;
  cursor: pointer;
  border: 1px solid transparent;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 116px;
}

.modal__save-button:hover {
  background-color: #50629b;
  border: 1px solid transparent;
  outline: none;
}

.save-button__img {
  width: 16px;
  height: 16px;
  background: url(@/assets/btn-save.svg) no-repeat center center;
  margin-right: 10px;
}

.preloader {
  display: flex;
  justify-content: center;
}

.report-body::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  background-color: #f9f9fd;
}

.report-body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #2d375744;
}

.report-body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  padding: 20px;
  /* border: 3px solid #000; */
  background-color: #e3e9f1;
}

.report-item__textarea {
  width: 100%; box-sizing: border-box;
  padding: 15px;
}

.item-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 5px;
}

.item-modal__title {
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-decoration-line: underline;
  color: #2d3757;
}

.report-table__item {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #2d3757;
  display: block;
  height: 100%;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  white-space: nowrap;
}

.item-modal__img {
  margin-left: 12px;
  height: 20px;
  width: 20px;
  background: url(@/assets/share.svg) no-repeat center center;
}

/* filter */

.filter {
  box-sizing: border-box;
  /* padding: 15px; */
  padding-bottom: 15px;
}

.filter__wrap {
  box-sizing: border-box;
  background: #f6faff;
  border: 1px solid #d3dfed;
  border-radius: 2px;
  padding: 10px 10px;
}

.filter__body {
  display: flex;
  align-items: center;
}

.filter__img {
  height: 24px;
  width: 24px;
  background: url(@/assets/filter.svg) no-repeat center center;
}

.filter__title {
  display: flex;
  align-items: center;
  padding-left: 5px;
}

.filter__title-text {
  padding-left: 15px;
  padding-right: 30px;
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  color: #2d3757;
}

.filter__items {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
}

.filter__item {
  padding: 10px 10px;
  flex: 1 1 auto;
  width: 40%;
}

.filter__item-title {
  padding-left: 10px;
  padding-bottom: 5px;
  font-size: 14px;
  color: #2d3757;
  font-weight: bold;
}

.filter__body .multiselect {
  width: 100%;
  z-index: 3;
}

.btn-apply {
  /* display: flex; */
  justify-content: end;
}

.btn-apply__body {
  /* background: rgb(106, 141, 255); */
  color: #fff;
  /* font-size: 1.25em; */
  padding: 10px 30px;
  margin-right: 20px;
  cursor: pointer;

  background: #2d3757;
  border-radius: 2px;

  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  /* line-height: 19px; */

  color: #ffffff;
}

.email-field {
  margin-bottom: 15px;
}
.email-input-row {
  display: flex;
  gap: 10px;
}
.email-input-row input {
  flex-grow: 1;
  padding: 5px;
}
.email-tags {
  margin-top: 5px;
}
.email-tag {
  display: inline-block;
  background: #dce9ff;
  padding: 3px 10px;
  margin: 2px;
  border-radius: 15px;
  font-size: 14px;
}
.remove-tag {
  margin-left: 8px;
  color: #c00;
  cursor: pointer;
}

.email-field {
  margin-bottom: 15px;
}

.email-input-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 5px;
  min-height: 42px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: text;
  margin-top: 5px;
}

.email-input-container input {
  flex-grow: 1;
  border: none;
  outline: none;
  min-width: 150px;
  font-size: 14px;
  padding: 4px;
  margin: 2px 0;
}

.email-input-container input::placeholder {
  color: var(--ms-placeholder-color,#9ca3af);
}
</style>